
import {Component, Emit, Prop, Vue, Watch} from "vue-property-decorator";
import HeaderBox from "@/components/query/dialogs/HeaderBox.vue";
import MessageBox from "@/components/query/dialogs/MessageBox.vue";
import ChangedDataField from "@/components/study/dataFieldChange/ChangedDataField.vue";
import {IDataFieldChangeReport} from "@/auxillary/datafield.changes";
import DataFieldChangeReason from "@/components/study/dataFieldChange/DataFieldChangeReason.vue";
import {MdbsCore} from "@/api/tsclient";
import AuditReasonOfChangeDto = MdbsCore.AuditReasonOfChangeDto;
import {dataFieldsEditModule} from "@/store";

@Component({
  components: {DataFieldChangeReason, ChangedDataField, HeaderBox, MessageBox}
})
export default class DataFieldsChangedDialog extends Vue {
  @Prop({required: true})
  changedFields!: Array<IDataFieldChangeReport>;
  reasons = ["Neue Information", "Dateneingabefehler", "Sonstiges"];
  objectReason = "";

  get changeReasons() {
    return this.reasons;
  }

  get isInvalid() {
    const fields = this.changedFields.traverse(field => field.childFields ?? []).filter(field => field.needsReasonForChange);
    return fields.some(field => !field.dataFieldCache.hasObjectReasonForChange)
  }

  @Watch('changedFields', {immediate: true})
  async onChangdFieldsChange(changedFields: Array<IDataFieldChangeReport> | null) {
    if (!changedFields) {
      console.error("error passing changedFields");
      return;
    }
  }

  @Watch('objectReason', {immediate: true})
  async onObjectReasonChange(objectReason: string | undefined) {
    if (objectReason != "") {
      this.updateGlobalReasonForChange(new AuditReasonOfChangeDto({objectReason: this.objectReason}))
    }
  }

  @Emit("abort")
  abort() {
    this.objectReason = "";
    this.updateGlobalReasonForChange(new AuditReasonOfChangeDto());
  }

  @Emit("ok")
  ok() {
    // Otherwise the collective reason of the previous save is still selected on the next dialog.
    this.objectReason = "";
  }

  updateGlobalReasonForChange(reasonForChange: AuditReasonOfChangeDto) {
    const fields = this.changedFields
        .traverse(field => field.childFields ?? [])
        .filter(field => field.needsReasonForChange && (!field.isPopulatedField || (field.isPopulatedField && !field.isReadonly)));
    for (const changeField of fields) {
      dataFieldsEditModule.setReasonForChange({
        field: changeField.dataFieldCache,
        reasonForChange: reasonForChange});
    }
  }
}

